import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { GhostArticle, ghost } from '@minerva-analytics/pantheon';
import { GHOST_API } from '../../constants';
import SubscribeForm from '../../components/SubscribeForm';
import SubscribeThanks from '../../components/SubscribeThanks';
import {
  ArticleContainer,
  ShareAndSubscribe,
  ShareText,
  ShareButtonContainer,
  FacebookShare,
  PinterestShare,
  CopyShare,
  EmailShare,
  TwitterShare,
  SubscriptionContainer,
  SubscribeTitle,
  SubscribeSubTitle,
  ShareContainer
} from './Article.styles';

const Article = () => {
  const colors = {
    body: `white`,
    link: `white`,
    title: `white`,
    header: `white`,
    quote: `white`,
    backto: `white`,
    published: `white`,
    author: `#1BE7FF`,
    readtime: `#2CEFBC`,
  };

  const fonts = {
    title: `Roboto, sans-serif`,
    header: `Roboto, sans-serif`,
    body: `Roboto, sans-serif`,
    backto: `Roboto, sans-serif`,
  };

  const adsense = {
    AdSenseTop: {
      slot: '2193732197',
    },
    AdSenseBottom: {
      slot: '3315242171',
    },
  };

  const theme = {
    ghostPublished: `font-weight: 400;`,
    ghostReadTime: `text-transform: uppercase; letter-spacing: 2px; font-weight: 500;`,
    ghostLink: `font-weight: 800; border-bottom: solid 2px #2CEFBC;`,
    ghostBackTo: `:before { content: " "; border-bottom: solid 2px #2CEFBC; width: 9.35rem; bottom: 0; position:absolute; }; margin-bottom: 0;`,
  };

  const article = ghost.hooks.useSelectedArticle();

  const status = useSelector(
    (state) => state.subscription.createSubscriberStatus
  );

  const success = status.loaded && !status.failed;

  return (
    <ArticleContainer>
      <ThemeProvider theme={theme}>
        <GhostArticle
          ghostApi={GHOST_API}
          domain='https://thequickscope.com'
          colors={colors}
          fonts={fonts}
          adsense={adsense}
        />
      </ThemeProvider>
      {article ? (
        <ShareAndSubscribe>
          <ShareContainer>
            <ShareText>Share This Article</ShareText>
            <ShareButtonContainer>
              <FacebookShare
                appId="516245735848059"
                url={`https://thequickscope.com/articles/${article.slug}`}
                description={article.title}
              />
              <TwitterShare
                body={`${article.title} - https://thequickscope.com/articles/${article.slug}`}
                link={`https://thequickscope.com/articles/${article.slug}`}
              />
              <PinterestShare
                appId="1456885"
                url={`https://thequickscope.com/articles/${article.slug}`}
                description={article.title}
                media=""
              />
              <EmailShare
                subject={`Check out: ${article.title}`}
                body={`Check out this article! https://thequickscope.com/articles/${article.slug}`}
              />
              <CopyShare />
            </ShareButtonContainer>
          </ShareContainer>
          {success ? <SubscribeThanks articleThanks /> : 
          <SubscriptionContainer>
            <SubscribeTitle>Want stories like this everyday?</SubscribeTitle>
            <SubscribeSubTitle>Sign up for daily gaming emails, for free</SubscribeSubTitle>
            <SubscribeForm page='article-page' />
          </SubscriptionContainer>
          }
        </ShareAndSubscribe>
      ) : null }
    </ArticleContainer>
  );
};

export default Article;